import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { Link } from 'react-router-dom';

const USDollar = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
});

const CredentialedServiceList = () => {
	const credServicesQuery = useQuery({
		queryKey: ['credentialed-services'],
		queryFn: async () => {
			const { data } = await axios.get(`/coord_agencies/credentialed-services`);
			data.forEach((healthplan) => {
				healthplan.grouped_services =
					healthplan.ilos_authorized_services.reduce((prev, next) => {
						if (!prev[next.external_211_services_id]) {
							prev[next.external_211_services_id] = [];
						}
						prev[next.external_211_services_id].push(next);
						return prev;
					}, {});
			});
			return data;
		},
	});
	return (
		<>
			<div className="breadcrumbs">
				<ul>
					<li>
						<Link to="/" className="link">
							Home
						</Link>
					</li>
					<li>
						<Link to="/ilos-panel" className="link">
							Billing
						</Link>
					</li>
					<li>Credentialed Services</li>
				</ul>
			</div>
			<div className="clear-both px-4 py-4 mt-2 bg-white rounded-lg">
				<h2>Credentialed Services</h2>
				<div className="divider" />
				{credServicesQuery.isFetching && (
					<span className="loading loading-spinner loading-lg"></span>
				)}
				{credServicesQuery?.data?.map((healthPlan) => (
					<div key={`hp-${healthPlan.id}`}>
						<h3>{healthPlan.healthplan_coord_agency.agency_name}</h3>
						{Object.keys(healthPlan?.grouped_services)?.map((serviceId) => (
							<div key={serviceId} className="my-4">
								<p>
									{
										healthPlan.grouped_services[serviceId][0]
											.external_211_service.data.name
									}
								</p>
								<table className="table table-xs">
									<thead>
										<tr>
											<td>Procedure Code</td>
											<td>Procedure Modifier</td>
											<td>Service Unit</td>
											<td>Service Unit Costs</td>
											<td>Duration</td>
											<td>Code Description</td>
										</tr>
									</thead>
									<tbody>
										{healthPlan.grouped_services[serviceId].map((service) => (
											<tr key={service.id}>
												<td>{service.procedure_code}</td>
												<td>{service.procedure_modifier}</td>
												<td>{service.service_unit}</td>
												<td>{USDollar.format(service.service_unit_cost)}</td>
												<td>
													{service.duration} {service.duration_unit}
												</td>
												<td>{service.procedure_code_description}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						))}
					</div>
				))}
			</div>
		</>
	);
};

export default CredentialedServiceList;
